import {Link} from 'react-router';
import React from 'react';

import {Subject} from './types';
import {Text} from '@albert-io/atomic';

interface Props {
  subject: Subject;
}

export function SubjectCard({subject}: Props) {
  const color = `var(--color-background-domain-${subject.curriculumArea.slug})`;

  return (
    <div
      className='flex w-full cursor-pointer items-center gap-x2 rounded-x1 p-x1 hover:background-primary-hover active:background-primary-pressed'
      onClick={(e) => (e.currentTarget.querySelector('a') as HTMLAnchorElement | null)?.click()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          (e.currentTarget.querySelector('a') as HTMLAnchorElement | null)?.click();
        }
      }}
      role='button'
      tabIndex={0}
    >
      <div
        className='flex h-x5 w-x5 min-w-x5 items-center justify-center rounded-full'
        style={{backgroundColor: color}}
      >
        {subject.logoUrl ? <img className='h-x3 w-x3' src={subject.logoUrl} alt='' /> : null}
      </div>

      <Text>
        <Link className='text-inherit no-underline' to={`/${subject.urlSlug}`}>
          {subject.name}
        </Link>
      </Text>
    </div>
  );
}
